import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $signInFormTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('sign_in'),
  redirectQuestion: t('do_not_have_account'),
  redirectLink: t('sign_up'),
}))
